import { render, staticRenderFns } from "./JoaEmployeeLeaveModal.vue?vue&type=template&id=4248bfdc&"
import script from "./JoaEmployeeLeaveModal.vue?vue&type=script&lang=js&"
export * from "./JoaEmployeeLeaveModal.vue?vue&type=script&lang=js&"
import style0 from "./JoaEmployeeLeaveModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports